module.exports = __webpack_public_path__ + "static/media/pousada_11.b3db0c41.jpg";